"use strict";
'use es6'; //WP006

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MON307_TTS_STYLE_OPTIONS = exports.MON307_TTS_STYLE_PARAMETER = exports.MON307_TREATMENT_KEY = exports.MON317_PAGE_DESIGN_OPTIONS = exports.MON317_PAGE_DESIGN_PARAMETER = exports.MON317_TREATMENT_KEY = exports.WP006_OPTIONS = exports.WP006_PARAMETER = exports.WP006_TREATMENT_KEY = void 0;
var WP006_TREATMENT_KEY = 'wordpress-006';
exports.WP006_TREATMENT_KEY = WP006_TREATMENT_KEY;
var WP006_PARAMETER = 'group';
exports.WP006_PARAMETER = WP006_PARAMETER;
var WP006_OPTIONS = {
  control: 'control',
  variant: 'variant'
};
exports.WP006_OPTIONS = WP006_OPTIONS;
var MON317_TREATMENT_KEY = 'cbx-april-7-2020-growth-cbx-317';
exports.MON317_TREATMENT_KEY = MON317_TREATMENT_KEY;
var MON317_PAGE_DESIGN_PARAMETER = 'page-design';
exports.MON317_PAGE_DESIGN_PARAMETER = MON317_PAGE_DESIGN_PARAMETER;
var MON317_PAGE_DESIGN_OPTIONS = {
  CONTROL: 'control',
  CONTENT_FORWARD: 'content-forward'
};
exports.MON317_PAGE_DESIGN_OPTIONS = MON317_PAGE_DESIGN_OPTIONS;
var MON307_TREATMENT_KEY = 'cbx-april-7-2020-growth-cbx-307';
exports.MON307_TREATMENT_KEY = MON307_TREATMENT_KEY;
var MON307_TTS_STYLE_PARAMETER = 'tts-style';
exports.MON307_TTS_STYLE_PARAMETER = MON307_TTS_STYLE_PARAMETER;
var MON307_TTS_STYLE_OPTIONS = {
  CONTROL: 'control',
  BELOW_TITLE: 'below-title',
  STICKY_HEADER: 'sticky-header',
  SIDE_FAB: 'side-fab'
};
exports.MON307_TTS_STYLE_OPTIONS = MON307_TTS_STYLE_OPTIONS;


//////////////////
// WEBPACK FOOTER
// ./js/constants/ExperimentConstants.js
// module id = 124
// module chunks = 5 6